import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAward, FiUsers, FiTool, FiTrendingUp } = FiIcons;

function Stats() {
  const stats = [
    {
      icon: FiAward,
      number: '20+',
      label: 'Years Experience',
      description: 'Building excellence since 2003'
    },
    {
      icon: FiUsers,
      number: '500+',
      label: 'Projects Completed',
      description: 'Successful deliveries'
    },
    {
      icon: FiTool,
      number: '50+',
      label: 'Expert Workers',
      description: 'Skilled professionals'
    },
    {
      icon: FiTrendingUp,
      number: '98%',
      label: 'Client Satisfaction',
      description: 'Happy customers'
    }
  ];

  return (
    <section className="py-20 bg-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center text-white"
            >
              <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={stat.icon} className="w-8 h-8 text-white" />
              </div>
              <div className="text-4xl font-bold text-primary mb-2">{stat.number}</div>
              <div className="text-xl font-semibold mb-2">{stat.label}</div>
              <div className="text-gray-400 text-sm">{stat.description}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Stats;